module.exports = __webpack_public_path__ + "static/media/download-solid.77a8feab.svg";